import React from 'react';

import './LoadingSpinner.css';

export const LoadingSpinner = () => {
  return (
    <div className="lds-ellipsis" role="progressbar">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

/*
export const LoadingSpinner2 = () => {
  return(<div className="loadingSpinner"><div className="spinner spinner__2"></div></div>
)}
*/
